export default "__VITE_ASSET__Dh4ZEep4__"